var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSkyline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 2108.19 274.71",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill: #dbdbdb;\n      }\n\n      .cls-3 {\n        fill: #a6a6a6;\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient);\n        opacity: .52;\n      }\n\n      .cls-5 {\n        fill: #c7c7c7;\n      }\n\n      .cls-6 {\n        fill: #ebebeb;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 1054.1,
    y1: 275.59,
    x2: 1054.1,
    y2: 17.99,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a9c4c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#c3d6d4",
    stopOpacity: 0.56
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#d9e5e4",
    stopOpacity: 0.2
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-83"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 452.21,
    y: 19.64,
    width: 48.66,
    height: 255.06
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 459.76,
    y: 27.92,
    width: 9.47,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 471.86,
    y: 27.92,
    width: 9.47,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 459.76,
    y: 44.47,
    width: 9.47,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 471.86,
    y: 44.47,
    width: 9.47,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 459.76,
    y: 60.99,
    width: 9.47,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 471.86,
    y: 60.99,
    width: 9.47,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 459.76,
    y: 77.54,
    width: 9.47,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 471.86,
    y: 77.54,
    width: 9.47,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 459.76,
    y: 94.06,
    width: 9.47,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 471.86,
    y: 94.06,
    width: 9.47,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 459.76,
    y: 110.61,
    width: 9.47,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 471.86,
    y: 110.61,
    width: 9.47,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 459.76,
    y: 127.13,
    width: 9.47,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 471.86,
    y: 127.13,
    width: 9.47,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 459.76,
    y: 143.67,
    width: 9.47,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 471.86,
    y: 143.67,
    width: 9.47,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 459.76,
    y: 160.2,
    width: 9.47,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 471.86,
    y: 160.2,
    width: 9.47,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 459.76,
    y: 176.74,
    width: 9.47,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 471.86,
    y: 176.74,
    width: 9.47,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 459.76,
    y: 193.27,
    width: 9.47,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 471.86,
    y: 193.27,
    width: 9.47,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 459.76,
    y: 209.81,
    width: 9.47,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 471.86,
    y: 209.81,
    width: 9.47,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 459.76,
    y: 226.34,
    width: 9.47,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 471.86,
    y: 226.34,
    width: 9.47,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 459.76,
    y: 242.88,
    width: 9.47,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 483.84,
    y: 242.88,
    width: 9.47,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 483.84,
    y: 226.36,
    width: 9.47,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 483.84,
    y: 209.81,
    width: 9.47,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 483.84,
    y: 193.29,
    width: 9.47,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 483.84,
    y: 176.74,
    width: 9.47,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 483.84,
    y: 160.22,
    width: 9.47,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 483.84,
    y: 143.66,
    width: 9.47,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 483.84,
    y: 127.13,
    width: 9.47,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 483.84,
    y: 110.59,
    width: 9.47,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 483.84,
    y: 94.06,
    width: 9.47,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 483.84,
    y: 77.52,
    width: 9.47,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 483.84,
    y: 60.99,
    width: 9.47,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 483.84,
    y: 44.45,
    width: 9.47,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 483.84,
    y: 27.92,
    width: 9.47,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 471.86,
    y: 242.88,
    width: 9.47,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 500.85,
    y: 19.64,
    width: 38.37,
    height: 255.06
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 527.46,
    y: 242.88,
    width: 7.81,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 517.46,
    y: 242.88,
    width: 7.81,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 527.46,
    y: 226.36,
    width: 7.81,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 517.46,
    y: 226.36,
    width: 7.81,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 527.46,
    y: 209.81,
    width: 7.81,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 517.46,
    y: 209.81,
    width: 7.81,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 527.46,
    y: 193.29,
    width: 7.81,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 517.46,
    y: 193.29,
    width: 7.81,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 527.46,
    y: 176.74,
    width: 7.81,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 517.46,
    y: 176.74,
    width: 7.81,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 527.46,
    y: 160.22,
    width: 7.81,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 517.46,
    y: 160.22,
    width: 7.81,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 527.46,
    y: 143.66,
    width: 7.81,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 517.46,
    y: 143.66,
    width: 7.81,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 527.46,
    y: 127.13,
    width: 7.81,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 517.46,
    y: 127.13,
    width: 7.81,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 527.46,
    y: 110.59,
    width: 7.81,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 517.46,
    y: 110.59,
    width: 7.81,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 527.46,
    y: 94.06,
    width: 7.81,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 517.46,
    y: 94.06,
    width: 7.81,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 527.46,
    y: 77.52,
    width: 7.81,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 517.46,
    y: 77.52,
    width: 7.81,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 527.46,
    y: 60.99,
    width: 7.81,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 517.46,
    y: 60.99,
    width: 7.81,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 527.46,
    y: 44.45,
    width: 7.81,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 517.46,
    y: 44.45,
    width: 7.81,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 527.46,
    y: 27.92,
    width: 7.81,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 507.56,
    y: 27.92,
    width: 7.81,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 507.56,
    y: 44.47,
    width: 7.81,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 507.56,
    y: 60.99,
    width: 7.81,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 507.56,
    y: 77.54,
    width: 7.81,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 507.56,
    y: 94.06,
    width: 7.81,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 507.56,
    y: 110.61,
    width: 7.81,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 507.56,
    y: 127.13,
    width: 7.81,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 507.56,
    y: 143.67,
    width: 7.81,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 507.56,
    y: 160.2,
    width: 7.81,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 507.56,
    y: 176.74,
    width: 7.81,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 507.56,
    y: 193.27,
    width: 7.81,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 507.56,
    y: 209.81,
    width: 7.81,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 507.56,
    y: 226.34,
    width: 7.81,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 507.56,
    y: 242.88,
    width: 7.81,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 517.46,
    y: 27.92,
    width: 7.81,
    height: 9.74
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1684.19,
    y: 19.64,
    width: 48.66,
    height: 255.06
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 1691.74,
    y: 27.92,
    width: 9.47,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 1703.84,
    y: 27.92,
    width: 9.47,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 1691.74,
    y: 44.47,
    width: 9.47,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 1703.84,
    y: 44.47,
    width: 9.47,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 1691.74,
    y: 60.99,
    width: 9.47,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 1703.84,
    y: 60.99,
    width: 9.47,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 1691.74,
    y: 77.54,
    width: 9.47,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 1703.84,
    y: 77.54,
    width: 9.47,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 1691.74,
    y: 94.06,
    width: 9.47,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 1703.84,
    y: 94.06,
    width: 9.47,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 1691.74,
    y: 110.61,
    width: 9.47,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 1703.84,
    y: 110.61,
    width: 9.47,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 1691.74,
    y: 127.13,
    width: 9.47,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 1703.84,
    y: 127.13,
    width: 9.47,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 1691.74,
    y: 143.67,
    width: 9.47,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 1703.84,
    y: 143.67,
    width: 9.47,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 1691.74,
    y: 160.2,
    width: 9.47,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 1703.84,
    y: 160.2,
    width: 9.47,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 1691.74,
    y: 176.74,
    width: 9.47,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 1703.84,
    y: 176.74,
    width: 9.47,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 1691.74,
    y: 193.27,
    width: 9.47,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 1703.84,
    y: 193.27,
    width: 9.47,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 1691.74,
    y: 209.81,
    width: 9.47,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 1703.84,
    y: 209.81,
    width: 9.47,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 1691.74,
    y: 226.34,
    width: 9.47,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 1703.84,
    y: 226.34,
    width: 9.47,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 1691.74,
    y: 242.88,
    width: 9.47,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 1715.82,
    y: 242.88,
    width: 9.47,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 1715.82,
    y: 226.36,
    width: 9.47,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 1715.82,
    y: 209.81,
    width: 9.47,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 1715.82,
    y: 193.29,
    width: 9.47,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 1715.82,
    y: 176.74,
    width: 9.47,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 1715.82,
    y: 160.22,
    width: 9.47,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 1715.82,
    y: 143.66,
    width: 9.47,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 1715.82,
    y: 127.13,
    width: 9.47,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 1715.82,
    y: 110.59,
    width: 9.47,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 1715.82,
    y: 94.06,
    width: 9.47,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 1715.82,
    y: 77.52,
    width: 9.47,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 1715.82,
    y: 60.99,
    width: 9.47,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 1715.82,
    y: 44.45,
    width: 9.47,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 1715.82,
    y: 27.92,
    width: 9.47,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 1703.84,
    y: 242.88,
    width: 9.47,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1732.84,
    y: 19.64,
    width: 38.37,
    height: 255.06
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1759.44,
    y: 242.88,
    width: 7.81,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1749.44,
    y: 242.88,
    width: 7.81,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1759.44,
    y: 226.36,
    width: 7.81,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1749.44,
    y: 226.36,
    width: 7.81,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1759.44,
    y: 209.81,
    width: 7.81,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1749.44,
    y: 209.81,
    width: 7.81,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1759.44,
    y: 193.29,
    width: 7.81,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1749.44,
    y: 193.29,
    width: 7.81,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1759.44,
    y: 176.74,
    width: 7.81,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1749.44,
    y: 176.74,
    width: 7.81,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1759.44,
    y: 160.22,
    width: 7.81,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1749.44,
    y: 160.22,
    width: 7.81,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1759.44,
    y: 143.66,
    width: 7.81,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1749.44,
    y: 143.66,
    width: 7.81,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1759.44,
    y: 127.13,
    width: 7.81,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1749.44,
    y: 127.13,
    width: 7.81,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1759.44,
    y: 110.59,
    width: 7.81,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1749.44,
    y: 110.59,
    width: 7.81,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1759.44,
    y: 94.06,
    width: 7.81,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1749.44,
    y: 94.06,
    width: 7.81,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1759.44,
    y: 77.52,
    width: 7.81,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1749.44,
    y: 77.52,
    width: 7.81,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1759.44,
    y: 60.99,
    width: 7.81,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1749.44,
    y: 60.99,
    width: 7.81,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1759.44,
    y: 44.45,
    width: 7.81,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1749.44,
    y: 44.45,
    width: 7.81,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1759.44,
    y: 27.92,
    width: 7.81,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1739.55,
    y: 27.92,
    width: 7.81,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1739.55,
    y: 44.47,
    width: 7.81,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1739.55,
    y: 60.99,
    width: 7.81,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1739.55,
    y: 77.54,
    width: 7.81,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1739.55,
    y: 94.06,
    width: 7.81,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1739.55,
    y: 110.61,
    width: 7.81,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1739.55,
    y: 127.13,
    width: 7.81,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1739.55,
    y: 143.67,
    width: 7.81,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1739.55,
    y: 160.2,
    width: 7.81,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1739.55,
    y: 176.74,
    width: 7.81,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1739.55,
    y: 193.27,
    width: 7.81,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1739.55,
    y: 209.81,
    width: 7.81,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1739.55,
    y: 226.34,
    width: 7.81,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1739.55,
    y: 242.88,
    width: 7.81,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1749.44,
    y: 27.92,
    width: 7.81,
    height: 9.74
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 251.61,
    y: 5.88,
    width: 57.56,
    height: 268.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 250.24,
    width: 58.94,
    height: 5.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 256.82,
    y: 14.57,
    width: 5.84,
    height: 260.15
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 267.15,
    y: 14.57,
    width: 5.84,
    height: 260.15
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 277.48,
    y: 14.57,
    width: 5.84,
    height: 260.15
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 287.81,
    y: 14.57,
    width: 5.84,
    height: 260.15
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 298.15,
    y: 14.57,
    width: 5.84,
    height: 260.15
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 256.82,
    y: 22,
    width: 5.84,
    height: 11.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 267.15,
    y: 22,
    width: 5.84,
    height: 11.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 277.48,
    y: 22,
    width: 5.84,
    height: 11.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 287.81,
    y: 22,
    width: 5.84,
    height: 11.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 298.15,
    y: 22,
    width: 5.84,
    height: 11.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 256.82,
    y: 40.88,
    width: 5.84,
    height: 11.63
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 267.15,
    y: 40.88,
    width: 5.84,
    height: 11.63
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 277.48,
    y: 40.88,
    width: 5.84,
    height: 11.63
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 287.81,
    y: 40.88,
    width: 5.84,
    height: 11.63
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 298.15,
    y: 40.88,
    width: 5.84,
    height: 11.63
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 256.82,
    y: 59.77,
    width: 5.84,
    height: 11.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 267.15,
    y: 59.77,
    width: 5.84,
    height: 11.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 277.48,
    y: 59.77,
    width: 5.84,
    height: 11.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 287.81,
    y: 59.77,
    width: 5.84,
    height: 11.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 298.15,
    y: 59.77,
    width: 5.84,
    height: 11.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 256.82,
    y: 78.64,
    width: 5.84,
    height: 11.63
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 267.15,
    y: 78.64,
    width: 5.84,
    height: 11.63
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 277.48,
    y: 78.64,
    width: 5.84,
    height: 11.63
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 287.81,
    y: 78.64,
    width: 5.84,
    height: 11.63
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 298.15,
    y: 78.64,
    width: 5.84,
    height: 11.63
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 256.82,
    y: 97.52,
    width: 5.84,
    height: 11.63
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 267.15,
    y: 97.52,
    width: 5.84,
    height: 11.63
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 277.48,
    y: 97.52,
    width: 5.84,
    height: 11.63
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 287.81,
    y: 97.52,
    width: 5.84,
    height: 11.63
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 298.15,
    y: 97.52,
    width: 5.84,
    height: 11.63
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 256.82,
    y: 116.41,
    width: 5.84,
    height: 11.63
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 267.15,
    y: 116.41,
    width: 5.84,
    height: 11.63
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 277.48,
    y: 116.41,
    width: 5.84,
    height: 11.63
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 287.81,
    y: 116.41,
    width: 5.84,
    height: 11.63
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 298.15,
    y: 116.41,
    width: 5.84,
    height: 11.63
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 256.82,
    y: 135.3,
    width: 5.84,
    height: 11.63
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 267.15,
    y: 135.3,
    width: 5.84,
    height: 11.63
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 277.48,
    y: 135.3,
    width: 5.84,
    height: 11.63
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 287.81,
    y: 135.3,
    width: 5.84,
    height: 11.63
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 298.15,
    y: 135.3,
    width: 5.84,
    height: 11.63
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 256.82,
    y: 154.17,
    width: 5.84,
    height: 11.63
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 267.15,
    y: 154.17,
    width: 5.84,
    height: 11.63
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 277.48,
    y: 154.17,
    width: 5.84,
    height: 11.63
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 287.81,
    y: 154.17,
    width: 5.84,
    height: 11.63
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 298.15,
    y: 154.17,
    width: 5.84,
    height: 11.63
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 256.82,
    y: 173.05,
    width: 5.84,
    height: 11.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 267.15,
    y: 173.05,
    width: 5.84,
    height: 11.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 277.48,
    y: 173.05,
    width: 5.84,
    height: 11.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 287.81,
    y: 173.05,
    width: 5.84,
    height: 11.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 298.15,
    y: 173.05,
    width: 5.84,
    height: 11.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 256.82,
    y: 191.94,
    width: 5.84,
    height: 11.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 267.15,
    y: 191.94,
    width: 5.84,
    height: 11.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 277.48,
    y: 191.94,
    width: 5.84,
    height: 11.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 287.81,
    y: 191.94,
    width: 5.84,
    height: 11.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 298.15,
    y: 191.94,
    width: 5.84,
    height: 11.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 256.82,
    y: 210.83,
    width: 5.84,
    height: 11.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 267.15,
    y: 210.83,
    width: 5.84,
    height: 11.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 277.48,
    y: 210.83,
    width: 5.84,
    height: 11.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 287.81,
    y: 210.83,
    width: 5.84,
    height: 11.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 298.15,
    y: 210.83,
    width: 5.84,
    height: 11.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 256.82,
    y: 229.7,
    width: 5.84,
    height: 11.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 267.15,
    y: 229.7,
    width: 5.84,
    height: 11.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 277.48,
    y: 229.7,
    width: 5.84,
    height: 11.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 287.81,
    y: 229.7,
    width: 5.84,
    height: 11.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 298.15,
    y: 229.7,
    width: 5.84,
    height: 11.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 256.82,
    y: 248.58,
    width: 5.84,
    height: 11.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 267.15,
    y: 248.58,
    width: 5.84,
    height: 11.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 277.48,
    y: 248.58,
    width: 5.84,
    height: 11.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 287.81,
    y: 248.58,
    width: 5.84,
    height: 11.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 298.15,
    y: 248.58,
    width: 5.84,
    height: 11.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 256.82,
    y: 267.47,
    width: 5.84,
    height: 7.25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 267.15,
    y: 267.47,
    width: 5.84,
    height: 7.25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 277.48,
    y: 267.47,
    width: 5.84,
    height: 7.25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 287.81,
    y: 267.47,
    width: 5.84,
    height: 7.25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 298.15,
    y: 267.47,
    width: 5.84,
    height: 7.25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 309.18,
    y: 5.88,
    width: 36.96,
    height: 268.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 309.18,
    width: 38.55,
    height: 5.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 314.38,
    y: 14.57,
    width: 5.84,
    height: 260.15
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 324.71,
    y: 14.57,
    width: 5.84,
    height: 260.15
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 335.05,
    y: 14.57,
    width: 5.84,
    height: 260.15
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 314.38,
    y: 22,
    width: 5.84,
    height: 11.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 324.71,
    y: 22,
    width: 5.84,
    height: 11.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 335.05,
    y: 22,
    width: 5.84,
    height: 11.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 314.38,
    y: 40.88,
    width: 5.84,
    height: 11.63
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 324.71,
    y: 40.88,
    width: 5.84,
    height: 11.63
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 335.05,
    y: 40.88,
    width: 5.84,
    height: 11.63
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 314.38,
    y: 59.77,
    width: 5.84,
    height: 11.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 324.71,
    y: 59.77,
    width: 5.84,
    height: 11.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 335.05,
    y: 59.77,
    width: 5.84,
    height: 11.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 314.38,
    y: 78.64,
    width: 5.84,
    height: 11.63
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 324.71,
    y: 78.64,
    width: 5.84,
    height: 11.63
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 335.05,
    y: 78.64,
    width: 5.84,
    height: 11.63
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 314.38,
    y: 97.52,
    width: 5.84,
    height: 11.63
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 324.71,
    y: 97.52,
    width: 5.84,
    height: 11.63
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 335.05,
    y: 97.52,
    width: 5.84,
    height: 11.63
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 314.38,
    y: 116.41,
    width: 5.84,
    height: 11.63
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 324.71,
    y: 116.41,
    width: 5.84,
    height: 11.63
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 335.05,
    y: 116.41,
    width: 5.84,
    height: 11.63
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 314.38,
    y: 135.3,
    width: 5.84,
    height: 11.63
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 324.71,
    y: 135.3,
    width: 5.84,
    height: 11.63
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 335.05,
    y: 135.3,
    width: 5.84,
    height: 11.63
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 314.38,
    y: 154.17,
    width: 5.84,
    height: 11.63
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 324.71,
    y: 154.17,
    width: 5.84,
    height: 11.63
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 335.05,
    y: 154.17,
    width: 5.84,
    height: 11.63
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 314.38,
    y: 173.05,
    width: 5.84,
    height: 11.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 324.71,
    y: 173.05,
    width: 5.84,
    height: 11.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 335.05,
    y: 173.05,
    width: 5.84,
    height: 11.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 314.38,
    y: 191.94,
    width: 5.84,
    height: 11.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 324.71,
    y: 191.94,
    width: 5.84,
    height: 11.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 335.05,
    y: 191.94,
    width: 5.84,
    height: 11.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 314.38,
    y: 210.83,
    width: 5.84,
    height: 11.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 324.71,
    y: 210.83,
    width: 5.84,
    height: 11.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 335.05,
    y: 210.83,
    width: 5.84,
    height: 11.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 314.38,
    y: 229.7,
    width: 5.84,
    height: 11.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 324.71,
    y: 229.7,
    width: 5.84,
    height: 11.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 335.05,
    y: 229.7,
    width: 5.84,
    height: 11.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 314.38,
    y: 248.58,
    width: 5.84,
    height: 11.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 324.71,
    y: 248.58,
    width: 5.84,
    height: 11.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 335.05,
    y: 248.58,
    width: 5.84,
    height: 11.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 314.38,
    y: 267.47,
    width: 5.84,
    height: 7.25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 324.71,
    y: 267.47,
    width: 5.84,
    height: 7.25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 335.05,
    y: 267.47,
    width: 5.84,
    height: 7.25
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    y: 104.68,
    width: 57.32,
    height: 170.02
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 8.16,
    y: 90.26,
    width: 49.17,
    height: 14.41
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 6.3,
    y: 112.2,
    width: 44.74,
    height: 162.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 6.3,
    y: 127.71,
    width: 44.74,
    height: 3.84
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 6.3,
    y: 143.61,
    width: 44.74,
    height: 3.84
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 6.3,
    y: 159.53,
    width: 44.74,
    height: 3.84
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 6.3,
    y: 175.43,
    width: 44.74,
    height: 3.84
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 6.3,
    y: 191.34,
    width: 44.74,
    height: 3.84
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 6.3,
    y: 207.24,
    width: 44.74,
    height: 3.84
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 6.3,
    y: 223.16,
    width: 44.74,
    height: 3.84
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 6.3,
    y: 239.05,
    width: 44.74,
    height: 3.84
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 6.3,
    y: 254.97,
    width: 44.74,
    height: 3.84
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 6.3,
    y: 270.87,
    width: 44.74,
    height: 3.84
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 57.32,
    y: 104.68,
    width: 35.9,
    height: 170.02
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 57.32,
    y: 90.26,
    width: 30.51,
    height: 14.41
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 62.28,
    y: 112.2,
    width: 27.6,
    height: 162.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 62.28,
    y: 127.71,
    width: 27.6,
    height: 3.84
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 62.28,
    y: 143.61,
    width: 27.6,
    height: 3.84
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 62.28,
    y: 159.53,
    width: 27.6,
    height: 3.84
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 62.28,
    y: 175.43,
    width: 27.6,
    height: 3.84
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 62.28,
    y: 191.34,
    width: 27.6,
    height: 3.84
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 62.28,
    y: 207.24,
    width: 27.6,
    height: 3.84
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 62.28,
    y: 223.16,
    width: 27.6,
    height: 3.84
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 62.28,
    y: 239.05,
    width: 27.6,
    height: 3.84
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 62.28,
    y: 254.97,
    width: 27.6,
    height: 3.84
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 62.28,
    y: 270.87,
    width: 27.6,
    height: 3.84
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 1308.43,
    y: 104.68,
    width: 57.32,
    height: 170.02
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1316.59,
    y: 90.26,
    width: 49.17,
    height: 14.41
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1314.72,
    y: 112.2,
    width: 44.74,
    height: 162.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1314.72,
    y: 127.71,
    width: 44.74,
    height: 3.84
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1314.72,
    y: 143.61,
    width: 44.74,
    height: 3.84
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1314.72,
    y: 159.53,
    width: 44.74,
    height: 3.84
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1314.72,
    y: 175.43,
    width: 44.74,
    height: 3.84
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1314.72,
    y: 191.34,
    width: 44.74,
    height: 3.84
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1314.72,
    y: 207.24,
    width: 44.74,
    height: 3.84
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1314.72,
    y: 223.16,
    width: 44.74,
    height: 3.84
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1314.72,
    y: 239.05,
    width: 44.74,
    height: 3.84
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1314.72,
    y: 254.97,
    width: 44.74,
    height: 3.84
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1314.72,
    y: 270.87,
    width: 44.74,
    height: 3.84
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1365.74,
    y: 104.68,
    width: 35.9,
    height: 170.02
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1365.74,
    y: 90.26,
    width: 30.51,
    height: 14.41
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1370.71,
    y: 112.2,
    width: 27.6,
    height: 162.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1370.71,
    y: 127.71,
    width: 27.6,
    height: 3.84
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1370.71,
    y: 143.61,
    width: 27.6,
    height: 3.84
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1370.71,
    y: 159.53,
    width: 27.6,
    height: 3.84
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1370.71,
    y: 175.43,
    width: 27.6,
    height: 3.84
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1370.71,
    y: 191.34,
    width: 27.6,
    height: 3.84
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1370.71,
    y: 207.24,
    width: 27.6,
    height: 3.84
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1370.71,
    y: 223.16,
    width: 27.6,
    height: 3.84
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1370.71,
    y: 239.05,
    width: 27.6,
    height: 3.84
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1370.71,
    y: 254.97,
    width: 27.6,
    height: 3.84
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1370.71,
    y: 270.87,
    width: 27.6,
    height: 3.84
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 544.78,
    y: 175.17,
    width: 44.31,
    height: 99.53
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 551.74,
    y: 183.79,
    width: 7.84,
    height: 6.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 551.74,
    y: 196.81,
    width: 7.84,
    height: 6.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 551.74,
    y: 209.83,
    width: 7.84,
    height: 6.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 551.74,
    y: 222.86,
    width: 7.84,
    height: 6.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 551.74,
    y: 235.88,
    width: 7.84,
    height: 6.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 551.74,
    y: 248.92,
    width: 7.84,
    height: 6.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 551.74,
    y: 261.94,
    width: 7.84,
    height: 6.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 563.03,
    y: 183.79,
    width: 7.84,
    height: 6.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 563.03,
    y: 196.81,
    width: 7.84,
    height: 6.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 563.03,
    y: 209.83,
    width: 7.84,
    height: 6.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 563.03,
    y: 222.86,
    width: 7.84,
    height: 6.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 563.03,
    y: 235.88,
    width: 7.84,
    height: 6.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 563.03,
    y: 248.92,
    width: 7.84,
    height: 6.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 563.03,
    y: 261.94,
    width: 7.84,
    height: 6.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 574.29,
    y: 183.79,
    width: 7.84,
    height: 6.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 574.29,
    y: 196.81,
    width: 7.84,
    height: 6.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 574.29,
    y: 209.83,
    width: 7.84,
    height: 6.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 574.29,
    y: 222.86,
    width: 7.84,
    height: 6.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 574.29,
    y: 235.88,
    width: 7.84,
    height: 6.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 574.29,
    y: 248.92,
    width: 7.84,
    height: 6.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 574.29,
    y: 261.94,
    width: 7.84,
    height: 6.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 589.08,
    y: 175.17,
    width: 31.09,
    height: 99.53
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 610.62,
    y: 260.96,
    width: 6.39,
    height: 6.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 610.62,
    y: 247.94,
    width: 6.39,
    height: 6.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 610.62,
    y: 234.92,
    width: 6.39,
    height: 6.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 610.62,
    y: 221.9,
    width: 6.39,
    height: 6.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 610.62,
    y: 208.86,
    width: 6.39,
    height: 6.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 610.62,
    y: 195.83,
    width: 6.39,
    height: 6.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 610.62,
    y: 182.83,
    width: 6.39,
    height: 6.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 601.43,
    y: 260.96,
    width: 6.39,
    height: 6.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 601.43,
    y: 247.94,
    width: 6.39,
    height: 6.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 601.43,
    y: 234.92,
    width: 6.39,
    height: 6.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 601.43,
    y: 221.9,
    width: 6.39,
    height: 6.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 601.43,
    y: 208.86,
    width: 6.39,
    height: 6.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 601.43,
    y: 195.83,
    width: 6.39,
    height: 6.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 601.43,
    y: 182.83,
    width: 6.39,
    height: 6.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 592.27,
    y: 260.96,
    width: 6.39,
    height: 6.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 592.27,
    y: 247.94,
    width: 6.39,
    height: 6.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 592.27,
    y: 234.92,
    width: 6.39,
    height: 6.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 592.27,
    y: 221.9,
    width: 6.39,
    height: 6.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 592.27,
    y: 208.86,
    width: 6.39,
    height: 6.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 592.27,
    y: 195.83,
    width: 6.39,
    height: 6.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 592.27,
    y: 182.83,
    width: 6.39,
    height: 6.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 854.87,
    y: 175.17,
    width: 44.31,
    height: 99.53
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 861.82,
    y: 183.79,
    width: 7.84,
    height: 6.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 861.82,
    y: 196.81,
    width: 7.84,
    height: 6.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 861.82,
    y: 209.83,
    width: 7.84,
    height: 6.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 861.82,
    y: 222.86,
    width: 7.84,
    height: 6.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 861.82,
    y: 235.88,
    width: 7.84,
    height: 6.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 861.82,
    y: 248.92,
    width: 7.84,
    height: 6.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 861.82,
    y: 261.94,
    width: 7.84,
    height: 6.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 873.11,
    y: 183.79,
    width: 7.84,
    height: 6.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 873.11,
    y: 196.81,
    width: 7.84,
    height: 6.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 873.11,
    y: 209.83,
    width: 7.84,
    height: 6.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 873.11,
    y: 222.86,
    width: 7.84,
    height: 6.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 873.11,
    y: 235.88,
    width: 7.84,
    height: 6.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 873.11,
    y: 248.92,
    width: 7.84,
    height: 6.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 873.11,
    y: 261.94,
    width: 7.84,
    height: 6.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 884.37,
    y: 183.79,
    width: 7.84,
    height: 6.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 884.37,
    y: 196.81,
    width: 7.84,
    height: 6.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 884.37,
    y: 209.83,
    width: 7.84,
    height: 6.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 884.37,
    y: 222.86,
    width: 7.84,
    height: 6.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 884.37,
    y: 235.88,
    width: 7.84,
    height: 6.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 884.37,
    y: 248.92,
    width: 7.84,
    height: 6.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 884.37,
    y: 261.94,
    width: 7.84,
    height: 6.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 899.17,
    y: 175.17,
    width: 31.09,
    height: 99.53
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 920.7,
    y: 260.96,
    width: 6.39,
    height: 6.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 920.7,
    y: 247.94,
    width: 6.39,
    height: 6.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 920.7,
    y: 234.92,
    width: 6.39,
    height: 6.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 920.7,
    y: 221.9,
    width: 6.39,
    height: 6.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 920.7,
    y: 208.86,
    width: 6.39,
    height: 6.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 920.7,
    y: 195.83,
    width: 6.39,
    height: 6.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 920.7,
    y: 182.83,
    width: 6.39,
    height: 6.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 911.51,
    y: 260.96,
    width: 6.39,
    height: 6.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 911.51,
    y: 247.94,
    width: 6.39,
    height: 6.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 911.51,
    y: 234.92,
    width: 6.39,
    height: 6.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 911.51,
    y: 221.9,
    width: 6.39,
    height: 6.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 911.51,
    y: 208.86,
    width: 6.39,
    height: 6.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 911.51,
    y: 195.83,
    width: 6.39,
    height: 6.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 911.51,
    y: 182.83,
    width: 6.39,
    height: 6.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 902.35,
    y: 260.96,
    width: 6.39,
    height: 6.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 902.35,
    y: 247.94,
    width: 6.39,
    height: 6.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 902.35,
    y: 234.92,
    width: 6.39,
    height: 6.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 902.35,
    y: 221.9,
    width: 6.39,
    height: 6.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 902.35,
    y: 208.86,
    width: 6.39,
    height: 6.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 902.35,
    y: 195.83,
    width: 6.39,
    height: 6.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 902.35,
    y: 182.83,
    width: 6.39,
    height: 6.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 2032.8,
    y: 175.17,
    width: 44.31,
    height: 99.53
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 2039.76,
    y: 183.79,
    width: 7.84,
    height: 6.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 2039.76,
    y: 196.81,
    width: 7.84,
    height: 6.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 2039.76,
    y: 209.83,
    width: 7.84,
    height: 6.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 2039.76,
    y: 222.86,
    width: 7.84,
    height: 6.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 2039.76,
    y: 235.88,
    width: 7.84,
    height: 6.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 2039.76,
    y: 248.92,
    width: 7.84,
    height: 6.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 2039.76,
    y: 261.94,
    width: 7.84,
    height: 6.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 2051.05,
    y: 183.79,
    width: 7.84,
    height: 6.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 2051.05,
    y: 196.81,
    width: 7.84,
    height: 6.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 2051.05,
    y: 209.83,
    width: 7.84,
    height: 6.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 2051.05,
    y: 222.86,
    width: 7.84,
    height: 6.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 2051.05,
    y: 235.88,
    width: 7.84,
    height: 6.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 2051.05,
    y: 248.92,
    width: 7.84,
    height: 6.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 2051.05,
    y: 261.94,
    width: 7.84,
    height: 6.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 2062.3,
    y: 183.79,
    width: 7.84,
    height: 6.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 2062.3,
    y: 196.81,
    width: 7.84,
    height: 6.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 2062.3,
    y: 209.83,
    width: 7.84,
    height: 6.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 2062.3,
    y: 222.86,
    width: 7.84,
    height: 6.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 2062.3,
    y: 235.88,
    width: 7.84,
    height: 6.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 2062.3,
    y: 248.92,
    width: 7.84,
    height: 6.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 2062.3,
    y: 261.94,
    width: 7.84,
    height: 6.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 2077.1,
    y: 175.17,
    width: 31.09,
    height: 99.53
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 2098.64,
    y: 260.96,
    width: 6.39,
    height: 6.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 2098.64,
    y: 247.94,
    width: 6.39,
    height: 6.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 2098.64,
    y: 234.92,
    width: 6.39,
    height: 6.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 2098.64,
    y: 221.9,
    width: 6.39,
    height: 6.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 2098.64,
    y: 208.86,
    width: 6.39,
    height: 6.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 2098.64,
    y: 195.83,
    width: 6.39,
    height: 6.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 2098.64,
    y: 182.83,
    width: 6.39,
    height: 6.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 2089.45,
    y: 260.96,
    width: 6.39,
    height: 6.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 2089.45,
    y: 247.94,
    width: 6.39,
    height: 6.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 2089.45,
    y: 234.92,
    width: 6.39,
    height: 6.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 2089.45,
    y: 221.9,
    width: 6.39,
    height: 6.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 2089.45,
    y: 208.86,
    width: 6.39,
    height: 6.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 2089.45,
    y: 195.83,
    width: 6.39,
    height: 6.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 2089.45,
    y: 182.83,
    width: 6.39,
    height: 6.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 2080.29,
    y: 260.96,
    width: 6.39,
    height: 6.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 2080.29,
    y: 247.94,
    width: 6.39,
    height: 6.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 2080.29,
    y: 234.92,
    width: 6.39,
    height: 6.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 2080.29,
    y: 221.9,
    width: 6.39,
    height: 6.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 2080.29,
    y: 208.86,
    width: 6.39,
    height: 6.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 2080.29,
    y: 195.83,
    width: 6.39,
    height: 6.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 2080.29,
    y: 182.83,
    width: 6.39,
    height: 6.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 627.68,
    y: 60.99,
    width: 30.62,
    height: 36.16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 658.28,
    y: 60.99,
    width: 19.41,
    height: 37.48
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 659.72,
    y: 76.97,
    width: 19.27,
    height: 21.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 678.99,
    y: 76.97,
    width: 12.01,
    height: 21.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 615.93,
    y: 94.81,
    width: 49.51,
    height: 179.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 621.6,
    y: 102.55,
    width: 15.56,
    height: 6.36
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 641.51,
    y: 102.55,
    width: 15.56,
    height: 6.36
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 621.6,
    y: 113.35,
    width: 15.56,
    height: 6.36
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 641.51,
    y: 113.35,
    width: 15.56,
    height: 6.36
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 621.6,
    y: 124.15,
    width: 15.56,
    height: 6.36
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 641.51,
    y: 124.15,
    width: 15.56,
    height: 6.36
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 621.6,
    y: 134.93,
    width: 15.56,
    height: 6.36
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 641.51,
    y: 134.93,
    width: 15.56,
    height: 6.36
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 621.6,
    y: 145.73,
    width: 15.56,
    height: 6.36
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 641.51,
    y: 145.73,
    width: 15.56,
    height: 6.36
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 621.6,
    y: 156.53,
    width: 15.56,
    height: 6.36
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 641.51,
    y: 156.53,
    width: 15.56,
    height: 6.36
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 621.6,
    y: 167.32,
    width: 15.56,
    height: 6.36
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 641.51,
    y: 167.32,
    width: 15.56,
    height: 6.36
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 621.6,
    y: 178.12,
    width: 15.56,
    height: 6.36
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 641.51,
    y: 178.12,
    width: 15.56,
    height: 6.36
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 621.6,
    y: 188.92,
    width: 15.56,
    height: 6.36
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 641.51,
    y: 188.92,
    width: 15.56,
    height: 6.36
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 621.6,
    y: 199.72,
    width: 15.56,
    height: 6.36
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 641.51,
    y: 199.72,
    width: 15.56,
    height: 6.36
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 621.6,
    y: 210.52,
    width: 15.56,
    height: 6.36
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 641.51,
    y: 210.52,
    width: 15.56,
    height: 6.36
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 621.6,
    y: 221.32,
    width: 15.56,
    height: 6.36
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 641.51,
    y: 221.32,
    width: 15.56,
    height: 6.36
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 621.6,
    y: 232.12,
    width: 15.56,
    height: 6.36
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 641.51,
    y: 232.12,
    width: 15.56,
    height: 6.36
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 621.6,
    y: 242.91,
    width: 15.56,
    height: 6.36
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 641.51,
    y: 242.91,
    width: 15.56,
    height: 6.36
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 665.44,
    y: 94.81,
    width: 40.12,
    height: 179.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 688.75,
    y: 242.93,
    width: 12.77,
    height: 6.36
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 672.41,
    y: 242.93,
    width: 12.77,
    height: 6.36
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 688.75,
    y: 232.13,
    width: 12.77,
    height: 6.36
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 672.41,
    y: 232.13,
    width: 12.77,
    height: 6.36
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 688.75,
    y: 221.33,
    width: 12.77,
    height: 6.36
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 672.41,
    y: 221.33,
    width: 12.77,
    height: 6.36
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 688.75,
    y: 210.53,
    width: 12.77,
    height: 6.36
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 672.41,
    y: 210.53,
    width: 12.77,
    height: 6.36
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 688.75,
    y: 199.74,
    width: 12.77,
    height: 6.36
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 672.41,
    y: 199.74,
    width: 12.77,
    height: 6.36
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 688.75,
    y: 188.94,
    width: 12.77,
    height: 6.36
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 672.41,
    y: 188.94,
    width: 12.77,
    height: 6.36
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 688.75,
    y: 178.14,
    width: 12.77,
    height: 6.36
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 672.41,
    y: 178.14,
    width: 12.77,
    height: 6.36
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 688.75,
    y: 167.34,
    width: 12.77,
    height: 6.36
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 672.41,
    y: 167.34,
    width: 12.77,
    height: 6.36
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 688.75,
    y: 156.54,
    width: 12.77,
    height: 6.36
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 672.41,
    y: 156.54,
    width: 12.77,
    height: 6.36
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 688.75,
    y: 145.74,
    width: 12.77,
    height: 6.36
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 672.41,
    y: 145.74,
    width: 12.77,
    height: 6.36
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 688.75,
    y: 134.94,
    width: 12.77,
    height: 6.36
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 672.41,
    y: 134.94,
    width: 12.77,
    height: 6.36
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 688.75,
    y: 124.13,
    width: 12.77,
    height: 6.36
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 672.41,
    y: 124.13,
    width: 12.77,
    height: 6.36
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 688.75,
    y: 113.33,
    width: 12.77,
    height: 6.36
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 672.41,
    y: 113.33,
    width: 12.77,
    height: 6.36
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 688.75,
    y: 102.53,
    width: 12.77,
    height: 6.36
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 672.41,
    y: 102.53,
    width: 12.77,
    height: 6.36
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 166.88,
    y: 157.48,
    width: 58.39,
    height: 117.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 176.06,
    y: 167.63,
    width: 10.34,
    height: 7.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 176.06,
    y: 182.96,
    width: 10.34,
    height: 7.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 176.06,
    y: 198.31,
    width: 10.34,
    height: 7.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 176.06,
    y: 213.64,
    width: 10.34,
    height: 7.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 176.06,
    y: 228.99,
    width: 10.34,
    height: 7.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 176.06,
    y: 244.32,
    width: 10.34,
    height: 7.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 176.06,
    y: 259.67,
    width: 10.34,
    height: 7.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 190.93,
    y: 167.63,
    width: 10.34,
    height: 7.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 190.93,
    y: 182.96,
    width: 10.34,
    height: 7.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 190.93,
    y: 198.31,
    width: 10.34,
    height: 7.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 190.93,
    y: 213.64,
    width: 10.34,
    height: 7.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 190.93,
    y: 228.99,
    width: 10.34,
    height: 7.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 190.93,
    y: 244.32,
    width: 10.34,
    height: 7.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 190.93,
    y: 259.67,
    width: 10.34,
    height: 7.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 205.76,
    y: 167.63,
    width: 10.34,
    height: 7.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 205.76,
    y: 182.96,
    width: 10.34,
    height: 7.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 205.76,
    y: 198.31,
    width: 10.34,
    height: 7.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 205.76,
    y: 213.64,
    width: 10.34,
    height: 7.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 205.76,
    y: 228.99,
    width: 10.34,
    height: 7.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 205.76,
    y: 244.32,
    width: 10.34,
    height: 7.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 205.76,
    y: 259.67,
    width: 10.34,
    height: 7.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 186.4,
    y: 145.27,
    width: 38.87,
    height: 12.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 200.63,
    y: 137.7,
    width: 24.65,
    height: 7.57
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 225.08,
    y: 157.48,
    width: 40.96,
    height: 117.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 253.45,
    y: 258.52,
    width: 8.41,
    height: 7.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 253.45,
    y: 243.17,
    width: 8.41,
    height: 7.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 253.45,
    y: 227.84,
    width: 8.41,
    height: 7.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 253.45,
    y: 212.49,
    width: 8.41,
    height: 7.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 253.45,
    y: 197.16,
    width: 8.41,
    height: 7.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 253.45,
    y: 181.81,
    width: 8.41,
    height: 7.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 253.45,
    y: 166.48,
    width: 8.41,
    height: 7.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 241.35,
    y: 258.52,
    width: 8.41,
    height: 7.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 241.35,
    y: 243.17,
    width: 8.41,
    height: 7.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 241.35,
    y: 227.84,
    width: 8.41,
    height: 7.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 241.35,
    y: 212.49,
    width: 8.41,
    height: 7.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 241.35,
    y: 197.16,
    width: 8.41,
    height: 7.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 241.35,
    y: 181.81,
    width: 8.41,
    height: 7.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 241.35,
    y: 166.48,
    width: 8.41,
    height: 7.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 229.28,
    y: 258.52,
    width: 8.41,
    height: 7.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 229.28,
    y: 243.17,
    width: 8.41,
    height: 7.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 229.28,
    y: 227.84,
    width: 8.41,
    height: 7.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 229.28,
    y: 212.49,
    width: 8.41,
    height: 7.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 229.28,
    y: 197.16,
    width: 8.41,
    height: 7.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 229.28,
    y: 181.81,
    width: 8.41,
    height: 7.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 229.28,
    y: 166.48,
    width: 8.41,
    height: 7.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 225.08,
    y: 145.27,
    width: 34.75,
    height: 12.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 225.08,
    y: 137.7,
    width: 18.84,
    height: 7.57
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1174.44,
    y: 157.48,
    width: 58.39,
    height: 117.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1183.61,
    y: 167.63,
    width: 10.34,
    height: 7.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1183.61,
    y: 182.96,
    width: 10.34,
    height: 7.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1183.61,
    y: 198.31,
    width: 10.34,
    height: 7.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1183.61,
    y: 213.64,
    width: 10.34,
    height: 7.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1183.61,
    y: 228.99,
    width: 10.34,
    height: 7.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1183.61,
    y: 244.32,
    width: 10.34,
    height: 7.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1183.61,
    y: 259.67,
    width: 10.34,
    height: 7.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1198.49,
    y: 167.63,
    width: 10.34,
    height: 7.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1198.49,
    y: 182.96,
    width: 10.34,
    height: 7.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1198.49,
    y: 198.31,
    width: 10.34,
    height: 7.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1198.49,
    y: 213.64,
    width: 10.34,
    height: 7.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1198.49,
    y: 228.99,
    width: 10.34,
    height: 7.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1198.49,
    y: 244.32,
    width: 10.34,
    height: 7.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1198.49,
    y: 259.67,
    width: 10.34,
    height: 7.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1213.31,
    y: 167.63,
    width: 10.34,
    height: 7.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1213.31,
    y: 182.96,
    width: 10.34,
    height: 7.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1213.31,
    y: 198.31,
    width: 10.34,
    height: 7.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1213.31,
    y: 213.64,
    width: 10.34,
    height: 7.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1213.31,
    y: 228.99,
    width: 10.34,
    height: 7.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1213.31,
    y: 244.32,
    width: 10.34,
    height: 7.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1213.31,
    y: 259.67,
    width: 10.34,
    height: 7.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1193.95,
    y: 145.27,
    width: 38.87,
    height: 12.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 1208.18,
    y: 137.7,
    width: 24.65,
    height: 7.57
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1232.64,
    y: 157.48,
    width: 40.96,
    height: 117.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1261.01,
    y: 258.52,
    width: 8.41,
    height: 7.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1261.01,
    y: 243.17,
    width: 8.41,
    height: 7.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1261.01,
    y: 227.84,
    width: 8.41,
    height: 7.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1261.01,
    y: 212.49,
    width: 8.41,
    height: 7.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1261.01,
    y: 197.16,
    width: 8.41,
    height: 7.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1261.01,
    y: 181.81,
    width: 8.41,
    height: 7.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1261.01,
    y: 166.48,
    width: 8.41,
    height: 7.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1248.9,
    y: 258.52,
    width: 8.41,
    height: 7.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1248.9,
    y: 243.17,
    width: 8.41,
    height: 7.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1248.9,
    y: 227.84,
    width: 8.41,
    height: 7.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1248.9,
    y: 212.49,
    width: 8.41,
    height: 7.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1248.9,
    y: 197.16,
    width: 8.41,
    height: 7.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1248.9,
    y: 181.81,
    width: 8.41,
    height: 7.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1248.9,
    y: 166.48,
    width: 8.41,
    height: 7.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1236.83,
    y: 258.52,
    width: 8.41,
    height: 7.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1236.83,
    y: 243.17,
    width: 8.41,
    height: 7.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1236.83,
    y: 227.84,
    width: 8.41,
    height: 7.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1236.83,
    y: 212.49,
    width: 8.41,
    height: 7.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1236.83,
    y: 197.16,
    width: 8.41,
    height: 7.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1236.83,
    y: 181.81,
    width: 8.41,
    height: 7.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1236.83,
    y: 166.48,
    width: 8.41,
    height: 7.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1232.64,
    y: 145.27,
    width: 34.75,
    height: 12.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1232.64,
    y: 137.7,
    width: 18.84,
    height: 7.57
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1743.45,
    y: 157.48,
    width: 58.39,
    height: 117.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1752.63,
    y: 167.63,
    width: 10.34,
    height: 7.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1752.63,
    y: 182.96,
    width: 10.34,
    height: 7.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1752.63,
    y: 198.31,
    width: 10.34,
    height: 7.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1752.63,
    y: 213.64,
    width: 10.34,
    height: 7.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1752.63,
    y: 228.99,
    width: 10.34,
    height: 7.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1752.63,
    y: 244.32,
    width: 10.34,
    height: 7.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1752.63,
    y: 259.67,
    width: 10.34,
    height: 7.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1767.5,
    y: 167.63,
    width: 10.34,
    height: 7.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1767.5,
    y: 182.96,
    width: 10.34,
    height: 7.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1767.5,
    y: 198.31,
    width: 10.34,
    height: 7.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1767.5,
    y: 213.64,
    width: 10.34,
    height: 7.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1767.5,
    y: 228.99,
    width: 10.34,
    height: 7.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1767.5,
    y: 244.32,
    width: 10.34,
    height: 7.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1767.5,
    y: 259.67,
    width: 10.34,
    height: 7.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1782.33,
    y: 167.63,
    width: 10.34,
    height: 7.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1782.33,
    y: 182.96,
    width: 10.34,
    height: 7.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1782.33,
    y: 198.31,
    width: 10.34,
    height: 7.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1782.33,
    y: 213.64,
    width: 10.34,
    height: 7.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1782.33,
    y: 228.99,
    width: 10.34,
    height: 7.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1782.33,
    y: 244.32,
    width: 10.34,
    height: 7.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1782.33,
    y: 259.67,
    width: 10.34,
    height: 7.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1762.97,
    y: 145.27,
    width: 38.87,
    height: 12.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 1777.19,
    y: 137.7,
    width: 24.65,
    height: 7.57
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1801.65,
    y: 157.48,
    width: 40.96,
    height: 117.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1830.02,
    y: 258.52,
    width: 8.41,
    height: 7.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1830.02,
    y: 243.17,
    width: 8.41,
    height: 7.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1830.02,
    y: 227.84,
    width: 8.41,
    height: 7.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1830.02,
    y: 212.49,
    width: 8.41,
    height: 7.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1830.02,
    y: 197.16,
    width: 8.41,
    height: 7.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1830.02,
    y: 181.81,
    width: 8.41,
    height: 7.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1830.02,
    y: 166.48,
    width: 8.41,
    height: 7.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1817.92,
    y: 258.52,
    width: 8.41,
    height: 7.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1817.92,
    y: 243.17,
    width: 8.41,
    height: 7.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1817.92,
    y: 227.84,
    width: 8.41,
    height: 7.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1817.92,
    y: 212.49,
    width: 8.41,
    height: 7.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1817.92,
    y: 197.16,
    width: 8.41,
    height: 7.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1817.92,
    y: 181.81,
    width: 8.41,
    height: 7.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1817.92,
    y: 166.48,
    width: 8.41,
    height: 7.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1805.85,
    y: 258.52,
    width: 8.41,
    height: 7.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1805.85,
    y: 243.17,
    width: 8.41,
    height: 7.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1805.85,
    y: 227.84,
    width: 8.41,
    height: 7.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1805.85,
    y: 212.49,
    width: 8.41,
    height: 7.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1805.85,
    y: 197.16,
    width: 8.41,
    height: 7.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1805.85,
    y: 181.81,
    width: 8.41,
    height: 7.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1805.85,
    y: 166.48,
    width: 8.41,
    height: 7.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1801.65,
    y: 145.27,
    width: 34.75,
    height: 12.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1801.65,
    y: 137.7,
    width: 18.84,
    height: 7.57
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 929.89,
    y: 19.64,
    width: 48.66,
    height: 255.06
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 937.44,
    y: 27.92,
    width: 9.47,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 949.54,
    y: 27.92,
    width: 9.47,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 937.44,
    y: 44.47,
    width: 9.47,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 949.54,
    y: 44.47,
    width: 9.47,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 937.44,
    y: 60.99,
    width: 9.47,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 949.54,
    y: 60.99,
    width: 9.47,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 937.44,
    y: 77.54,
    width: 9.47,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 949.54,
    y: 77.54,
    width: 9.47,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 937.44,
    y: 94.06,
    width: 9.47,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 949.54,
    y: 94.06,
    width: 9.47,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 937.44,
    y: 110.61,
    width: 9.47,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 949.54,
    y: 110.61,
    width: 9.47,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 937.44,
    y: 127.13,
    width: 9.47,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 949.54,
    y: 127.13,
    width: 9.47,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 937.44,
    y: 143.67,
    width: 9.47,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 949.54,
    y: 143.67,
    width: 9.47,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 937.44,
    y: 160.2,
    width: 9.47,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 949.54,
    y: 160.2,
    width: 9.47,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 937.44,
    y: 176.74,
    width: 9.47,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 949.54,
    y: 176.74,
    width: 9.47,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 937.44,
    y: 193.27,
    width: 9.47,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 949.54,
    y: 193.27,
    width: 9.47,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 937.44,
    y: 209.81,
    width: 9.47,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 949.54,
    y: 209.81,
    width: 9.47,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 937.44,
    y: 226.34,
    width: 9.47,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 949.54,
    y: 226.34,
    width: 9.47,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 937.44,
    y: 242.88,
    width: 9.47,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 961.52,
    y: 242.88,
    width: 9.47,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 961.52,
    y: 226.36,
    width: 9.47,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 961.52,
    y: 209.81,
    width: 9.47,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 961.52,
    y: 193.29,
    width: 9.47,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 961.52,
    y: 176.74,
    width: 9.47,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 961.52,
    y: 160.22,
    width: 9.47,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 961.52,
    y: 143.66,
    width: 9.47,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 961.52,
    y: 127.13,
    width: 9.47,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 961.52,
    y: 110.59,
    width: 9.47,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 961.52,
    y: 94.06,
    width: 9.47,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 961.52,
    y: 77.52,
    width: 9.47,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 961.52,
    y: 60.99,
    width: 9.47,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 961.52,
    y: 44.45,
    width: 9.47,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 961.52,
    y: 27.92,
    width: 9.47,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 949.54,
    y: 242.88,
    width: 9.47,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 978.53,
    y: 19.64,
    width: 38.37,
    height: 255.06
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1005.14,
    y: 242.88,
    width: 7.81,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 995.14,
    y: 242.88,
    width: 7.81,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1005.14,
    y: 226.36,
    width: 7.81,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 995.14,
    y: 226.36,
    width: 7.81,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1005.14,
    y: 209.81,
    width: 7.81,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 995.14,
    y: 209.81,
    width: 7.81,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1005.14,
    y: 193.29,
    width: 7.81,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 995.14,
    y: 193.29,
    width: 7.81,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1005.14,
    y: 176.74,
    width: 7.81,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 995.14,
    y: 176.74,
    width: 7.81,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1005.14,
    y: 160.22,
    width: 7.81,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 995.14,
    y: 160.22,
    width: 7.81,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1005.14,
    y: 143.66,
    width: 7.81,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 995.14,
    y: 143.66,
    width: 7.81,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1005.14,
    y: 127.13,
    width: 7.81,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 995.14,
    y: 127.13,
    width: 7.81,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1005.14,
    y: 110.59,
    width: 7.81,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 995.14,
    y: 110.59,
    width: 7.81,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1005.14,
    y: 94.06,
    width: 7.81,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 995.14,
    y: 94.06,
    width: 7.81,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1005.14,
    y: 77.52,
    width: 7.81,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 995.14,
    y: 77.52,
    width: 7.81,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1005.14,
    y: 60.99,
    width: 7.81,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 995.14,
    y: 60.99,
    width: 7.81,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1005.14,
    y: 44.45,
    width: 7.81,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 995.14,
    y: 44.45,
    width: 7.81,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1005.14,
    y: 27.92,
    width: 7.81,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 985.24,
    y: 27.92,
    width: 7.81,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 985.24,
    y: 44.47,
    width: 7.81,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 985.24,
    y: 60.99,
    width: 7.81,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 985.24,
    y: 77.54,
    width: 7.81,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 985.24,
    y: 94.06,
    width: 7.81,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 985.24,
    y: 110.61,
    width: 7.81,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 985.24,
    y: 127.13,
    width: 7.81,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 985.24,
    y: 143.67,
    width: 7.81,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 985.24,
    y: 160.2,
    width: 7.81,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 985.24,
    y: 176.74,
    width: 7.81,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 985.24,
    y: 193.27,
    width: 7.81,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 985.24,
    y: 209.81,
    width: 7.81,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 985.24,
    y: 226.34,
    width: 7.81,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 985.24,
    y: 242.88,
    width: 7.81,
    height: 9.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 995.14,
    y: 27.92,
    width: 7.81,
    height: 9.74
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m500.87,19.64h38.35v255.06h-87.02V19.64h48.66ZM250.24,0v5.88h1.38v139.39h-7.69v-7.57h-43.3v7.57h-14.23v12.21h-19.51v117.22h89.94v.02h5.84v-.02h4.49v.02h5.84v-.02h4.5v.02h5.84v-.02h4.49v.02h5.84v-.02h4.5v.02h5.84v-.02h10.4v.02h5.84v-.02h4.49v.02h5.84v-.02h4.5v.02h5.84v-.02h5.25V5.88h1.59V0h-97.49ZM87.83,90.26H8.16v14.41H0v170.02h6.3v.02h44.74v-.02h11.24v.02h27.6v-.02h3.34V104.68h-5.39v-14.41Zm1308.43,0h-79.66v14.41h-8.16v170.02h6.3v.02h44.74v-.02h11.24v.02h27.6v-.02h3.34V104.68h-5.39v-14.41Zm680.86,84.9h-44.31v99.53h75.39v-99.53h-31.08ZM691,76.97h-12.01v17.84h0v-17.84h-1.3v-15.98h-50.01v33.82h-11.75v80.35h-71.15v99.53h71.15v.02h89.62V94.81h-14.55v-17.84Zm576.39,68.3h-15.91v-7.57h-43.3v7.57h-14.23v12.21h-19.51v117.22h99.16v-117.22h-6.2v-12.21Zm569.01,0h-15.91v-7.57h-43.3v7.57h-5.99V19.64h-87.02v255.06h158.42v-117.22h-6.2v-12.21ZM978.53,19.64h-48.65v155.53h-75.02v99.53h162.03V19.64h-38.37Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkyline);
export default __webpack_public_path__ + "static/media/skyline.c2d334879212e897132faf22c58eaa5b.svg";
export { ForwardRef as ReactComponent };